import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output, OnChanges } from '@angular/core';
import { ValueAccessor } from '../../value-accessor/value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TrafficLightColor } from '../../../analysis/models/criterions/TrafficLightColor';
import { SliderChangeEvent, SliderSlideEndEvent } from 'primeng/slider';

@Component({
    selector: 'sera-range-slider',
    templateUrl: './sera-range-slider.component.html',
    styleUrl: './sera-range-slider.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraRangeSliderComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraRangeSliderComponent extends ValueAccessor<number> implements OnChanges {
    @Input()
    inputId!: string;

    @Input()
    isDisabled: boolean = false;

    @Input()
    isReadOnly: boolean = false;

    @Input()
    formControlName: string = '';

    @Input()
    label: string = '';

    @Input()
    hintLabel: string = '';

    @Input()
    color: TrafficLightColor | null = null;

    colorClass: string = 'sera-range-slider';

    @Input()
    displayMinAndMax: boolean = false;

    @Input()
    min: number = 0;

    @Input()
    max: number = 100;

    @Output()
    slideChange = new EventEmitter<number>();

    @Output()
    slideEnd = new EventEmitter<number>();

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(): void {
        this.setColorClass();
    }

    onSlideChangeFn(event: SliderChangeEvent): void {
        this.slideChange.emit(event.value);
        this.value = event.value!;
    }

    onSlideEndFn(event: SliderSlideEndEvent): void {
        this.slideEnd.emit(event.value);
        this.value = event.value!;
    }

    private setColorClass(): void {
        const baseClass = 'sera-range-slider';

        let colorClassSuffix;

        switch (this.color) {
            case TrafficLightColor.YELLOW:
                colorClassSuffix = '--yellow';
                break;
            case TrafficLightColor.RED:
                colorClassSuffix = '--red';
                break;
            case TrafficLightColor.GREEN:
                colorClassSuffix = '--green';
                break;
            case null:
            default:
                colorClassSuffix = '';
        }

        this.colorClass = this.isReadOnly ? 'sera-range-slider--read-only' : `${baseClass}${colorClassSuffix}`;
    }
}
